import React, { FC, memo, useState } from 'react';
import { TableCell, TableRow } from '@material-ui/core';
import classNames from 'classnames';

import { Actions, Datum, Column } from './types';
import TableBodyCell from './TableBodyCell';
import useStyles from './styles';

interface Props {
  datum: Datum;
  index: number;
  columns: Column[];
  actions: Actions;
}

const TableBodyRowMemoized: FC<Props> = memo(function TableBodyRow(props) {
  const { columns, actions, datum, index } = props;

  const classes = useStyles();
  const [highlightedIndex, setHighlightedIndex] = useState(null);

  const isHighlighted = highlightedIndex === index;
  const actionClasses = classNames(classes.tableCell, {
    [classes.hide]: !isHighlighted,
  });

  return (
    <TableRow
      hover
      classes={{ root: classes.tableRow, hover: classes.hover }}
      onMouseEnter={() => setHighlightedIndex(index)}
      onMouseLeave={() => setHighlightedIndex(null)}
    >
      {columns.map((column, index) => (
        <TableBodyCell
          key={index}
          datum={datum}
          column={column}
          index={index}
          columnLength={columns.length}
          isHighlighted={isHighlighted}
        />
      ))}
      <TableCell padding="none" className={actionClasses}>
        {actions(datum)}
      </TableCell>
    </TableRow>
  );
});

export default TableBodyRowMemoized;
